var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"errorBox"},[_c('span',{on:{"click":_vm.loginOut}},[_vm._v("返回登录页")])])}
var staticRenderFns = []

export { render, staticRenderFns }